<script lang="ts">
import { defineAsyncComponent } from 'vue';

export default {
    components: {
        PersonaHumanitas: defineAsyncComponent(() => import('./components/PersonaHumanitas.vue')),
    },
    data() {
        return {
            scriptLoaded: false,
            isAnimating: false,
        };
    },
    mounted() {
        this.initIntersectionObserver();
        setTimeout(() => {
            this.isAnimating = true; // Actualiza la propiedad después del delay
        }, 50);
    },
    methods: {
        initIntersectionObserver() {
            const target = document.getElementById('bolsaT');
            if (target) {
                const observer = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && !this.scriptLoaded) {
                    this.loadScript();
                    observer.disconnect(); // Desconectar después de cargar el script
                }
                });
                observer.observe(target);
            }
        },
        loadScript() {
            const script = document.createElement('script');
            script.id = 'bolsa-widget';
            script.type = 'text/javascript';
            script.charset = 'UTF-8';
            script.src = 'https://jobdiscovery-widget-occ.occ.com.mx/vertical-bundle.js';
            script.setAttribute('key', '2Nl8jyI2ufhVyI9aTYwjoEJFjBC');
            const target = document.getElementById('bolsaT');
            if (target) {
                target.appendChild(script);
                this.scriptLoaded = true;
            }
        },
    },
};
</script>

<template>
    <section class="flex pt-[88px] lg:pt-[150px] justify-center items-center mb-12 w-screen flex-col">
        <div class="flex items-center justify-center w-screen bg-center bg-cover md:bg-top bg-no-repeat" style="background-image: linear-gradient(transparent, rgba(255, 255, 255, 0.95)), url(/pagesImages/docs-bolsa.jpg);">
            <div class="flex justify-center w-full">
                <div class="flex text-justify w-full justify-center md:justify-end items-center max-w-4xl lg:max-w-[1200px] bg-white/50 md:bg-transparent">
                    <div :class="['w-full box h-fit md:h-[500px] md:w-[60%] lg:w-[45%] flex my-12 text-right md:my-0 flex-col justify-center lg:px-2 px-8', { 'visible': isAnimating }]">
                            <h1 class="">
                                <span class="block font-normal text-right mb-0 text-[30px] text-hwine">Bolsa de trabajo</span>
                                <span class="sr-only whitespace-nowrap">&nbsp;</span>
                                <span class="block font-serif text-hwine text-[50px] mb-2">Universidad Humanitas</span>
                            </h1>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="flex items-center justify-center w-full mb-16">
        <div class="flex flex-col lg:flex-row items-center justify-end w-full max-w-4xl lg:max-w-[1200px]">
            <div id="bolsaT" class="order-2 z-30 lg:order-1 flex flex-col items-center justify-center lg:z-10 " v-once>
                <div id="occ-widget" class="w-full">
                    <img src="https://jobdiscovery-widget-occ.occ.com.mx/loadspinner.gif" alt="Cargando">
                        Cargando OCC Widget
                </div>
            </div>
            <div class="order-1 lg:order-2 flex flex-col w-full px-4 lg:w-[600px] lg:h-[640px] justify-center text-justify lg:pl-8 my-8 lg:my-0 text-lg">
                <p class=" text-hgold text-left lg:px-0 px-4 lg:text-[42px] text-[36px] font-serif mb-4 leading-tight">
                    “El éxito profesional está a un click de distancia.”
                </p>
                <p class="mb-4">En Universidad Humanitas nos esforzamos cada día por brindarte un mejor servicio. La bolsa de Trabajo Humanitas es prueba de este compromiso, con él, buscamos retribuir la confianza que nos brindas al permitirnos formar parte de esta etapa de tu vida.</p>
                <p class="mb-4">Nuestro objetivo es impulsar el desarrollo profesional a través de la oferta de vacantes exclusivas con empresas vinculadas con la Universidad. Regístrate y sube tu currículum para que tu perfil laboral se encuentre activo y a la vista de los reclutadores.</p>
                <!-- <h2 class="text-hgold text-center md:text-left font-serif text-[26px] mb-4 leading-tight w-full">¿Qué ofrecemos?</h2>
                <ul class="list-disc pl-5 mb-4">
                    <li>Vacantes especializadas en empresas vinculadas a la universidad.</li>
                    <li>Visibilidad ante reclutadores de alto nivel.</li>
                </ul>
                <p class="mb-4">Únete a nuestra Bolsa de Trabajo Humanitas y descubre un mundo de oportunidades. ¡Tu futuro profesional comienza aquí!</p> -->
            </div>
        </div>
    </section>

    <PersonaHumanitas />
</template>

<style scoped>
.box {
    transform: translateX(160%); /* Fuera del viewport */
    transition: transform 1.2s ease-in-out;
}

.box.visible {
    transform: translateX(0); /* Posición original */
}
</style>